<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Group Contact Information</h2>
                            <hr>
                            <contact-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <contact-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import ContactForm from '../../components/Registration/ContactInfo/ContactForm.vue'
import ContactSideInfo from '../../components/Registration/ContactInfo/ContactSideInfo.vue'
export default {
    name: 'ContactInfo',
    components: {
        ContactForm,
        ContactSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>